<template>
  <div>
    <transition name="fade" mode="out-in">
      <div
        class="loading"
        style="height: 100vh; background: orange"
        v-if="loading"
        key="loading"
      >
        <pulse-loader
          color="#ffffff"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -28.5px;
            margin-top: -12px;
          "
        ></pulse-loader>
      </div>
      <div v-else key="cotent">
        <div v-if="line_error">
          <error-page></error-page>
        </div>
        <div
          v-else
          style="
            background: white;
            max-width: 380px;
            width: 100%;
            margin: auto;
            border: 1px solid #eee;
          "
        >
          <div
            class="text-center"
            :style="{ 'background-image': 'url(./img/bg.png)' }"
            style="
              min-height: 300px;
              background-repeat: no-repeat;
              background-size: cover;
              background-position: center;
            "
          >
            <template v-if="tuinuiid">
              <img
                :src="'./img/tuinui/mon_' + tuinuiid + '.png'"
                :alt="tuinui"
                style="max-width: 300px; margin: auto"
              />
            </template>
          </div>
          <div class="container-fluid">
            <div class="col-xs-12">
              <h1 style="color: orange; margin-bottom: 25px">
                ตุ้ยนุ้ย{{ tuinuiid | getTuinui }}
              </h1>

              <p>ตุ้ยนุ้ยของพี่ {{ display_name }}</p>

              <div class="row">
                <div class="col-xs-6" style="padding-right: 3px">
                  <a
                    href="javascript:void(0);"
                    class="btn"
                    :class="{
                      'btn-primary': currentView == 'status',
                      'btn-default': currentView != 'status',
                    }"
                    @click="currentView = 'status'"
                    style="width: 100%"
                    >Status</a
                  >
                </div>
                <div class="col-xs-6" style="padding-left: 3px">
                  <a
                    href="javascript:void(0);"
                    class="btn"
                    :class="{
                      'btn-primary': currentView == 'card',
                      'btn-default': currentView != 'card',
                    }"
                    @click="currentView = 'card'"
                    style="width: 100%"
                    >Tuinui Cards</a
                  >
                </div>
              </div>
              <div v-show="currentView == 'status'">
                <p style="padding-top: 15px">พลังงานสะสมต่อวัน</p>
                <div class="kcal text-right">
                  <span class="value">{{ cal | numberFormat }}</span
                  ><span class="unit">kcal</span>
                </div>
                <br />
                <h3 style="color: orange">Level: {{ level }}</h3>
                <div class="row">
                  <div class="col-xs-3">Exp</div>
                  <div class="col-xs-9 text-right">
                    {{ exp }} / {{ exp_limit[level - 1] }}
                  </div>
                </div>
                <div
                  style="
                    background: #eee;
                    border-radius: 10px;
                    overflow: hidden;
                    margin-top: 5px;
                  "
                >
                  <div
                    :style="{ width: (exp * 100) / exp_limit[level - 1] + '%' }"
                    style="background: #90f73a; height: 20px"
                  ></div>
                </div>

                <br />
                <h3 style="color: orange">
                  สถานะ <span class="helper" @click="showHelp = true">?</span>
                </h3>
                <div class="row stat">
                  <div class="col-xs-5 title">
                    <img
                      :src="'./img/status/str.png'"
                      alt=""
                      style="width: 35px; margin-right: 5px"
                    />
                    STR
                  </div>
                  <div class="col-xs-7 detail">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-status"
                      :disabled="stat.str == old_stat.str"
                      @click="
                        if (stat.str > old_stat.str) {
                          status_point++;
                          stat.str--;
                        }
                      "
                      >-</a
                    >
                    <p
                      style="
                        display: inline-block;
                        width: 75px;
                        text-align: center;
                      "
                      class="value"
                      :class="{ change: stat.str != old_stat.str }"
                    >
                      {{ stat.str }}
                      {{ bonus_stat.str ? " + " + bonus_stat.str : "" }}
                    </p>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-status"
                      :disabled="status_point <= 0"
                      @click="
                        if (status_point > 0) {
                          status_point--;
                          stat.str++;
                        }
                      "
                      >+</a
                    >
                  </div>
                </div>
                <div class="row stat">
                  <div class="col-xs-5 title">
                    <img
                      :src="'./img/status/agi.png'"
                      alt=""
                      style="width: 35px; margin-right: 5px"
                    />
                    AGI
                  </div>
                  <div class="col-xs-7 detail">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-status"
                      :disabled="stat.agi == old_stat.agi"
                      @click="
                        if (stat.agi > old_stat.agi) {
                          status_point++;
                          stat.agi--;
                        }
                      "
                      >-</a
                    >
                    <p
                      style="
                        display: inline-block;
                        width: 75px;
                        text-align: center;
                      "
                      class="value"
                      :class="{ change: stat.agi != old_stat.agi }"
                    >
                      {{ stat.agi }}
                      {{ bonus_stat.agi ? " + " + bonus_stat.agi : "" }}
                    </p>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-status"
                      :disabled="status_point <= 0"
                      @click="
                        if (status_point > 0) {
                          status_point--;
                          stat.agi++;
                        }
                      "
                      >+</a
                    >
                  </div>
                </div>
                <div class="row stat">
                  <div class="col-xs-5 title">
                    <img
                      :src="'./img/status/vit.png'"
                      alt=""
                      style="width: 35px; margin-right: 5px"
                    />
                    VIT
                  </div>
                  <div class="col-xs-7 detail">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-status"
                      :disabled="stat.vit == old_stat.vit"
                      @click="
                        if (stat.vit > old_stat.vit) {
                          status_point++;
                          stat.vit--;
                        }
                      "
                      >-</a
                    >
                    <p
                      style="
                        display: inline-block;
                        width: 75px;
                        text-align: center;
                      "
                      class="value"
                      :class="{ change: stat.vit != old_stat.vit }"
                    >
                      {{ stat.vit }}
                      {{ bonus_stat.vit ? " + " + bonus_stat.vit : "" }}
                    </p>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-status"
                      :disabled="status_point <= 0"
                      @click="
                        if (status_point > 0) {
                          status_point--;
                          stat.vit++;
                        }
                      "
                      >+</a
                    >
                  </div>
                </div>
                <div class="row stat">
                  <div class="col-xs-5 title">
                    <img
                      :src="'./img/status/dex.png'"
                      alt=""
                      style="width: 35px; margin-right: 5px"
                    />
                    DEX
                  </div>
                  <div class="col-xs-7 detail">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-status"
                      :disabled="stat.dex == old_stat.dex"
                      @click="
                        if (stat.dex > old_stat.dex) {
                          status_point++;
                          stat.dex--;
                        }
                      "
                      >-</a
                    >
                    <p
                      style="
                        display: inline-block;
                        width: 75px;
                        text-align: center;
                      "
                      class="value"
                      :class="{ change: stat.dex != old_stat.dex }"
                    >
                      {{ stat.dex }}
                      {{ bonus_stat.dex ? " + " + bonus_stat.dex : "" }}
                    </p>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-status"
                      :disabled="status_point <= 0"
                      @click="
                        if (status_point > 0) {
                          status_point--;
                          stat.dex++;
                        }
                      "
                      >+</a
                    >
                  </div>
                </div>
                <hr />
                <div class="row stat">
                  <div class="col-xs-12">
                    <p>Available Points: {{ status_point }}</p>
                  </div>
                </div>

                <div class="text-right" v-if="!isSaving">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-save-status"
                    :disabled="!isChange"
                    @click="
                      if (isChange) {
                        saveStat();
                      }
                    "
                    >Save</a
                  >
                </div>
                <div class="text-right" v-else>
                  <pulse-loader color="#ffa500" size="10"></pulse-loader>
                </div>

                <br />
                <h3 style="color: orange">ข้อมูลสารอาหาร</h3>
                <template v-if="nutrient.data != null">
                  <doughnut-chart
                    class="chart"
                    :chart-data="nutrient.data"
                    :options="nutrient.option"
                  ></doughnut-chart>
                </template>
                <template v-else>
                  <div class="text-center">
                    <pulse-loader color="#ffa500"></pulse-loader>
                  </div>
                </template>

                <br />
              </div>
              <div v-show="currentView == 'card'">
                <div class="row tuinui-card">
                  <div
                    class="col-xs-4"
                    v-for="(card, index) in tuinuiCard"
                    :key="'card_' + index"
                    style="padding: 0; padding-right: 5px"
                  >
                    <div
                      class="card"
                      :class="{ disabled: !card.owned }"
                      @click="selectTuinuiCard(card, index)"
                      :style="{
                        'border-color': tuinuiid == index ? 'orange' : '',
                      }"
                    >
                      <div class="card-img">
                        <img
                          :src="'./img/tuinui/mon_' + index + '.png'"
                          class="img-responsive"
                          v-if="card.owned"
                        />
                        <img
                          :src="
                            './img/tuinui_black/mon_black_' + index + '.png'
                          "
                          class="img-responsive"
                          v-else
                        />
                      </div>

                      <p
                        class="text-center"
                        style="
                          min-height: 20px;
                          margin-top: 5px;
                          margin-bottom: 3px;
                        "
                      >
                        <template v-if="card.owned">{{
                          index | getTuinui
                        }}</template
                        ><template v-else>???</template>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <modal-tuinui-card
            v-if="showTuinuiCard"
            @close="showTuinuiCard = false"
          >
            <template slot="header">&nbsp;</template>
            <div class="text-center" slot="body">
              <div v-if="currentTuinuiCard">
                <div
                  style="width: 100%; padding: 15px; border-radius: 5px"
                  :style="{
                    background: currentTuinuiCard.owned ? '#c1f5ff' : '#6d6d6d',
                  }"
                >
                  <img
                    :src="'./img/tuinui/mon_' + currentTuinuiCard.id + '.png'"
                    class="img-responsive"
                    style="margin: auto"
                    v-if="currentTuinuiCard.owned"
                  />
                  <img
                    :src="
                      './img/tuinui_black/mon_black_' +
                      currentTuinuiCard.id +
                      '.png'
                    "
                    class="img-responsive"
                    v-else
                    style="margin: auto"
                  />
                </div>

                <h3>
                  <template v-if="currentTuinuiCard.owned"
                    >ตุ้ยนุ้ย{{ currentTuinuiCard.id | getTuinui }}</template
                  ><template v-else>???</template>
                </h3>
                <!-- <p><template v-if="currentTuinuiCard.owned">-</template><template v-else>???</template></p> -->

                <div v-if="currentTuinuiCard.stat">
                  <div class="row stat">
                    <div class="col-xs-5 title">
                      <img
                        :src="'./img/status/str.png'"
                        alt=""
                        style="width: 35px; margin-right: 5px"
                      />
                      STR
                    </div>
                    <div class="col-xs-6 detail text-right">
                      +{{ currentTuinuiCard.stat.str }}
                    </div>
                  </div>
                  <div class="row stat">
                    <div class="col-xs-5 title">
                      <img
                        :src="'./img/status/agi.png'"
                        alt=""
                        style="width: 35px; margin-right: 5px"
                      />
                      AGI
                    </div>
                    <div class="col-xs-6 detail text-right">
                      +{{ currentTuinuiCard.stat.agi }}
                    </div>
                  </div>
                  <div class="row stat">
                    <div class="col-xs-5 title">
                      <img
                        :src="'./img/status/vit.png'"
                        alt=""
                        style="width: 35px; margin-right: 5px"
                      />
                      VIT
                    </div>
                    <div class="col-xs-6 detail text-right">
                      +{{ currentTuinuiCard.stat.vit }}
                    </div>
                  </div>
                  <div class="row stat">
                    <div class="col-xs-5 title">
                      <img
                        :src="'./img/status/dex.png'"
                        alt=""
                        style="width: 35px; margin-right: 5px"
                      />
                      DEX
                    </div>
                    <div class="col-xs-6 detail text-right">
                      +{{ currentTuinuiCard.stat.dex }}
                    </div>
                  </div>
                </div>
                <p v-if="currentTuinuiCard.owned">
                  กด transform เพื่อเปลี่ยนร่างตุ้ยนุ้ย<br /><span class="small"
                    >(สามารถเปลี่ยนร่างตุ้ยนุ้ยได้เมื่อเลเวลเกิน 25
                    ขึ้นไป)</span
                  >
                </p>
              </div>
            </div>
            <div class="text-center" slot="footer">
              <button
                class="btn"
                v-if="
                  currentTuinuiCard &&
                  currentTuinuiCard.owned &&
                  currentTuinuiCard.id != tuinuiid
                "
                :disabled="level < 25 ? true : false"
                :class="{
                  'btn-primary': level >= 25,
                  'btn-default': level < 25,
                }"
                @click="transformTuinui"
              >
                Transform
              </button>
              <button class="btn btn-default" @click="showTuinuiCard = false">
                Close
              </button>
            </div>
          </modal-tuinui-card>
          <div style="padding: 35px; background: #eee">
            <p class="small text-center" style="margin: 0">
              Powered by <br />
              Robolingo Co.,Ltd. <br />
              <a href="https://zwiz.ai">Zwiz.ai</a>
            </p>
          </div>

          <modal-dialog v-if="showHelp" @close="showHelp = false">
            <h3 slot="header">ค่าสถานะ</h3>

            <div slot="body">
              <h4>
                <img
                  :src="'./img/status/str.png'"
                  alt=""
                  style="width: 35px; margin-right: 5px"
                />
                STR (Strength)
              </h4>
              <p>ค่าพลังการโจมตีใส่คู่ต่อสู้</p>
              <br />
              <h4>
                <img
                  :src="'./img/status/agi.png'"
                  alt=""
                  style="width: 35px; margin-right: 5px"
                />
                AGI (Agility)
              </h4>
              <p>ความเร็วในการหลบหลีกคู่ต่อสู้</p>
              <br />
              <h4>
                <img
                  :src="'./img/status/vit.png'"
                  alt=""
                  style="width: 35px; margin-right: 5px"
                />
                VIT (Vitality)
              </h4>
              <p>เพิ่มจำนวน hit point สูงสุดของตุ้ยนุ้ย</p>
              <br />
              <h4>
                <img
                  :src="'./img/status/dex.png'"
                  alt=""
                  style="width: 35px; margin-right: 5px"
                />
                DEX (Dexterity)
              </h4>
              <p>ความแม่นยำในการโจมตี</p>

              <br />
              <h4>Available Points</h4>
              <p>
                แต้มที่ได้จากการเลเวลอัพในแต่ละครั้ง สามารถนำมาอัพค่าสถานะต่างๆ
                เพื่อทำให้ตุ้ยนุ้ยแข็งแกร่งขึ้น
              </p>
            </div>
          </modal-dialog>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import DoughnutChart from "@/views/components/DoughnutChart";
import ModalDialog from "@/views/components/ModalDialog";
import ModalTuinuiCard from "@/views/components/ModalTuinuiCard";
import ErrorPage from "@/views/components/ErrorPage.vue";

export default {
  components: {
    PulseLoader,
    DoughnutChart,
    ModalDialog,
    ErrorPage,
    ModalTuinuiCard,
  },
  data: function () {
    return {
      currentView: "status",
      nutrient: {
        data: null,
        option: {
          responsive: true,
          maintainAspectRatio: false,
        },
      },
      loading: false,

      userid: null, //U3f1e5f8f6c6d8245863376ead18d6824 / U15dcdd6825d0efae99fb8f144ed7cfd1
      display_name: "",
      tuinuiid: null,
      tuinui: null,
      level: 1,
      exp: 0,
      cal: 0,
      stat: {
        str: 0,
        agi: 0,
        vit: 0,
        dex: 0,
      },
      bonus_stat: {
        str: 0,
        agi: 0,
        vit: 0,
        dex: 0,
      },
      old_stat: {
        str: 0,
        agi: 0,
        vit: 0,
        dex: 0,
      },
      status_point: 0,
      protein_percent: 0,
      carbohydrate_percent: 0,
      fat_percent: 0,

      isSaving: false,
      line_error: false,

      showHelp: false,
      showTuinuiCard: false,
      currentTuinuiCard: null,
      tuinuiCard: {
        1: {
          description: "",
          owned: false,
        },
        2: {
          description: "",
          owned: false,
        },
        3: {
          description: "",
          owned: false,
        },
        4: {
          description: "",
          owned: false,
        },
        5: {
          description: "",
          owned: false,
        },
        6: {
          description: "",
          owned: false,
        },
        7: {
          description: "",
          owned: false,
        },
        8: {
          description: "",
          owned: false,
        },
        9: {
          description: "",
          owned: false,
        },
        10: {
          description: "",
          owned: false,
        },
        11: {
          description: "",
          owned: false,
        },
        12: {
          description: "",
          owned: false,
        },
        13: {
          description: "",
          owned: false,
        },
        14: {
          description: "",
          owned: false,
        },
        15: {
          description: "",
          owned: false,
        },
        16: {
          description: "",
          owned: false,
        },
        17: {
          description: "",
          owned: false,
        },
        18: {
          description: "",
          owned: false,
        },
        19: {
          description: "",
          owned: false,
        },
        20: {
          description: "",
          owned: false,
        },
        21: {
          description: "",
          owned: false,
        },
        22: {
          description: "",
          owned: false,
        },
        23: {
          description: "",
          owned: false,
        },
        24: {
          description: "",
          owned: false,
        },
        25: {
          description: "",
          owned: false,
        },
        26: {
          description: "",
          owned: false,
        },
        27: {
          description: "",
          owned: false,
        },
        28: {
          description: "",
          owned: false,
        },
        29: {
          description: "",
          owned: false,
        },
        30: {
          description: "",
          owned: false,
        },
        31: {
          description: "",
          owned: false,
        },
        32: {
          description: "",
          owned: false,
        },
        33: {
          description: "",
          owned: false,
        },
        34: {
          description: "",
          owned: false,
        },
      },

      exp_limit: [
        100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200, 210, 220, 230,
        240, 250, 260, 270, 280, 290, 300, 310, 320, 330, 340, 350, 360, 370,
        380, 390, 400, 410, 420, 430, 440, 450, 460, 470, 480, 490, 500, 510,
        520, 530, 540, 550, 560, 570, 580, 590, 600, 610, 620, 630, 640, 650,
        660, 670, 680, 690, 700, 710, 720, 730, 740, 750, 760, 770, 780, 790,
        800, 810, 820, 830, 840, 850, 860, 870, 880, 890, 900, 910, 920, 930,
        940, 950, 960, 970, 980, 990, 1000, 1010, 1020, 1030, 1040, 1050, 1060,
        1070, 1080, 1090,
      ],
    };
  },
  computed: {
    isChange: function () {
      var vm = this;
      return (
        vm.stat.str + vm.stat.agi + vm.stat.vit + vm.stat.dex !=
        vm.old_stat.str + vm.old_stat.agi + vm.old_stat.vit + vm.old_stat.dex
      );
    },
  },
  mounted: async function () {
    this.loading = true;

    try {
      await this.$liff.init({
        liffId: process.env.VUE_APP_LIFF_ID, // Use own liffId
      });
      if (this.$liff.isLoggedIn()) {
        const profile = await this.$liff.getProfile();
        this.display_name = profile.displayName;
        this.userid = profile.userId;
        await this.loadProfile();
        await this.getTuinuiCard();
        this.loading = false;
      } else this.$liff.login();
    } catch (error) {
      this.line_error = true;
    }
    this.loading = false;
  },
  methods: {
    loadProfile: function () {
      var vm = this;
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";
      return new Promise((resolve, reject) => {
        $.ajax({
          url:
            SERVER_URL +
            "getuserprofile?userid=" +
            vm.userid +
            "__148369119115215",
          type: "GET",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function (result) {
            if (result.responsecode == 200 && result.data != null) {
              var row = result.data[0];
              var current_tuinui_id = parseInt(row.current_tuinui_id);
              var current_level = parseInt(row.current_level);
              var current_exp = parseInt(row.current_exp);
              var current_cal = parseInt(row.number_storage);
              var current_str = parseInt(row.current_str);
              var current_agi = parseInt(row.current_agi);
              var current_vit = parseInt(row.current_vit);
              var current_dex = parseInt(row.current_dex);
              var current_status_point = parseInt(row.current_status_point);
              var current_fat = parseFloat(row.current_fat);
              var current_carbohydrate = parseFloat(row.current_carbohydrate);
              var current_protein = parseFloat(row.current_protein);
              //   var current_diamond = parseInt(row.current_diamond);
              var total_nutrition =
                current_fat + current_carbohydrate + current_protein;
              if (total_nutrition == 0) total_nutrition = 1;

              vm.tuinuiid = current_tuinui_id;
              vm.level = current_level;
              vm.exp = current_exp;
              vm.cal = current_cal;
              vm.stat.str = current_str;
              vm.stat.agi = current_agi;
              vm.stat.vit = current_vit;
              vm.stat.dex = current_dex;

              vm.bonus_stat.str = parseInt(row.bonus_str);
              vm.bonus_stat.agi = parseInt(row.bonus_agi);
              vm.bonus_stat.vit = parseInt(row.bonus_vit);
              vm.bonus_stat.dex = parseInt(row.bonus_dex);

              vm.old_stat.str = current_str;
              vm.old_stat.agi = current_agi;
              vm.old_stat.vit = current_vit;
              vm.old_stat.dex = current_dex;

              vm.status_point = current_status_point;
              vm.protein_percent = parseFloat(
                (current_protein * 100) / total_nutrition
              ).toFixed(2);
              vm.carbohydrate_percent = parseFloat(
                (current_carbohydrate * 100) / total_nutrition
              ).toFixed(2);
              vm.fat_percent = parseFloat(
                (current_fat * 100) / total_nutrition
              ).toFixed(2);

              vm.nutrient.data = vm.fillNutrient([
                vm.protein_percent,
                vm.carbohydrate_percent,
                vm.fat_percent,
              ]);

              //   vm.tuinui = vm.getTuinui(vm.tuinuiid)
              resolve();
            } else {
              vm.line_error = true;
              resolve();
            }
          },
          error: function (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            vm.line_error = true;

            reject();
          },
        });
      });
    },
    getTuinuiCard: function () {
      var vm = this;
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";
      return new Promise((resolve, reject) => {
        $.ajax({
          url:
            SERVER_URL +
            "getusersachievement?userid=" +
            vm.userid +
            "__148369119115215",
          type: "GET",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function (result) {
            if (result.responsecode == 200) {
              if (result.data) {
                var row = result.data;
                $.each(row, function (index, val) {
                  vm.tuinuiCard[val.tuinui_id].owned = true;
                });
              }

              resolve();
            } else {
              vm.line_error = true;
              reject();
            }
          },
          error: function (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            vm.line_error = true;
            reject();
          },
        });
      });
    },
    selectTuinuiCard: function (card, index) {
      var vm = this;
      vm.currentTuinuiCard = card;
      vm.currentTuinuiCard.id = index;
      vm.currentTuinuiCard.stat = vm.getTuinuiBonusStat(index);
      vm.showTuinuiCard = true;
    },
    transformTuinui: function () {
      var vm = this;
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";
      if (
        !vm.currentTuinuiCard ||
        vm.currentTuinuiCard == null ||
        vm.level < 25 ||
        vm.currentTuinuiCard.id > 34 ||
        vm.currentTuinuiCard.id < 1
      ) {
        return false;
      }

      var data = {
        userid: vm.userid + "__148369119115215",
        tuinui_id: vm.currentTuinuiCard.id,
      };
      vm.isSaving = true;
      $.ajax({
        url: SERVER_URL + "updatetuinui",
        type: "POST",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(data),
        success: function (result) {
          if (result.responsecode == 200 && result.data != null) {
            vm.showTuinuiCard = false;
            location.reload();
          }
        },
        error: function (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          vm.showTuinuiCard = false;
        },
      });
    },
    saveStat: function () {
      var vm = this;
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";

      var data = {
        userid: vm.userid + "__148369119115215",
        add_str: vm.stat.str - vm.old_stat.str,
        add_agi: vm.stat.agi - vm.old_stat.agi,
        add_vit: vm.stat.vit - vm.old_stat.vit,
        add_dex: vm.stat.dex - vm.old_stat.dex,
      };
      vm.isSaving = true;
      $.ajax({
        url: SERVER_URL + "updateuserprofilestatus",
        type: "POST",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(data),
        success: function (result) {
          if (result.responsecode == 200 && result.data != null) {
            vm.old_stat.str = vm.stat.str;
            vm.old_stat.agi = vm.stat.agi;
            vm.old_stat.vit = vm.stat.vit;
            vm.old_stat.dex = vm.stat.dex;
          }
          vm.isSaving = false;
        },
        error: function (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          vm.isSaving = false;
        },
      });
    },
    fillNutrient: function (data) {
      return {
        labels: ["โปรตีน", "คาร์โบไฮเดรต", "ไขมัน"],
        datasets: [
          {
            backgroundColor: ["#ff4141", "#41adff", "#ffbf41"],
            data: data,
          },
        ],
      };
    },
    getTuinuiBonusStat: function (tuinui_id) {
      var bonus_str = 0;
      var bonus_agi = 0;
      var bonus_vit = 0;
      var bonus_dex = 0;

      if (tuinui_id == 1) {
        bonus_dex = 1;
      } else if (tuinui_id == 2) {
        bonus_str = 1;
      } else if (tuinui_id == 3) {
        bonus_vit = 1;
      } else if (tuinui_id == 4) {
        bonus_str = 3;
        bonus_agi = 2;
      } else if (tuinui_id == 5) {
        bonus_vit = 5;
      } else if (tuinui_id == 6) {
        bonus_dex = 3;
        bonus_agi = 2;
      } else if (tuinui_id == 7) {
        bonus_str = 5;
        bonus_agi = 5;
      } else if (tuinui_id == 8) {
        bonus_str = 5;
      } else if (tuinui_id == 9) {
        bonus_str = 10;
      } else if (tuinui_id == 10) {
        bonus_dex = 5;
        bonus_agi = 5;
      } else if (tuinui_id == 11) {
        bonus_vit = 10;
      } else if (tuinui_id == 12) {
        bonus_dex = 5;
      } else if (tuinui_id == 13) {
        bonus_dex = 10;
      } else if (tuinui_id == 14) {
        bonus_dex = 15;
      } else if (tuinui_id == 15) {
        bonus_dex = 5;
        bonus_agi = 5;
        bonus_str = 5;
      } else if (tuinui_id == 16) {
        bonus_agi = 15;
      } else if (tuinui_id == 17) {
        bonus_vit = 15;
      } else if (tuinui_id == 18) {
        bonus_str = 15;
      } else if (tuinui_id == 19) {
        bonus_str = 5;
        bonus_agi = 5;
        bonus_vit = 5;
        bonus_dex = 5;
      } else if (tuinui_id == 20) {
        bonus_str = 10;
        bonus_vit = 10;
      } else if (tuinui_id == 21) {
        bonus_str = 20;
      } else if (tuinui_id == 22) {
        bonus_agi = 10;
        bonus_dex = 10;
      } else if (tuinui_id == 23) {
        bonus_vit = 10;
        bonus_dex = 10;
      } else if (tuinui_id == 24) {
        bonus_str = 10;
        bonus_agi = 5;
        bonus_dex = 5;
      } else if (tuinui_id == 25) {
        bonus_agi = 10;
        bonus_vit = 5;
        bonus_dex = 5;
      } else if (tuinui_id == 26) {
        bonus_str = 10;
        bonus_vit = 5;
        bonus_dex = 5;
      } else if (tuinui_id == 27) {
        bonus_str = 5;
        bonus_agi = 5;
        bonus_vit = 5;
        bonus_dex = 5;
      } else if (tuinui_id == 28) {
        bonus_agi = 20;
      } else if (tuinui_id == 29) {
        bonus_vit = 20;
      } else if (tuinui_id == 30) {
        bonus_str = 10;
        bonus_agi = 10;
      } else if (tuinui_id == 31) {
        bonus_str = 5;
        bonus_vit = 10;
        bonus_dex = 5;
      } else if (tuinui_id == 32) {
        bonus_agi = 5;
        bonus_vit = 5;
        bonus_dex = 10;
      } else if (tuinui_id == 33) {
        bonus_dex = 20;
      } else if (tuinui_id == 34) {
        bonus_agi = 20;
      }

      return {
        str: bonus_str,
        agi: bonus_agi,
        vit: bonus_vit,
        dex: bonus_dex,
      };
    },
  },

  watch: {
    showTuinuiCard: function (newVal) {
      if (newVal) {
        $("body").addClass("modal-open");
      } else {
        $("body").removeClass("modal-open");
      }
    },
  },
};
</script>

<style scoped></style>
